export default __webpack_public_path__ + "static/phone2-ef4cb703ecb161ecafbf60b3ad93030a.png";